import { useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Footer from '../../home/components/Footer';

const LoginPage = () => {
	const navigate = useNavigate();
	
	return (
		<div className="min-h-screen bg-gray-50">
			<nav className="bg-white shadow-sm sticky top-0 z-50">
				<div className="max-w-7xl mx-auto px-4 py-4">
					<div className="flex items-center justify-between">
						<button onClick={() => navigate(-1)} className="flex items-center space-x-2 text-gray-700 hover:text-purple-600 transition-colors cursor-pointer">
							<i className="ri-arrow-left-line text-xl"></i>
							<span className="font-bold text-xl">AIKnow 라이브 클래스</span>
						</button>
					</div>
				</div>
			</nav>
			<Login/>
			<Footer/>
		</div>
	);
}

export default LoginPage;